import { jsx as _jsx } from "react/jsx-runtime";
/**
 * React Context Provider for HTTP Service
 * Provides HTTP service instance to React components via context
 */
import { createContext, useContext, useMemo } from "react";
import { HttpService } from "./HttpService";
const HttpContext = createContext(null);
/**
 * Provider component that creates and provides HTTP service instance
 */
export const HttpProvider = ({ children, getAuthToken, envConfig, onAuthError, defaultTimeout, defaultHeaders, }) => {
    const httpService = useMemo(() => {
        const config = {
            getAuthToken,
            envConfig,
            ...(onAuthError && { onAuthError }),
            ...(defaultTimeout && { defaultTimeout }),
            ...(defaultHeaders && { defaultHeaders }),
        };
        return new HttpService(config);
    }, [getAuthToken, envConfig, onAuthError, defaultTimeout, defaultHeaders]);
    const contextValue = useMemo(() => ({
        httpService,
        getAuthToken,
    }), [httpService, getAuthToken]);
    return _jsx(HttpContext.Provider, { value: contextValue, children: children });
};
/**
 * Hook to access HTTP context
 * @throws Error if used outside HttpProvider
 */
export function useHttpContext() {
    const context = useContext(HttpContext);
    if (!context) {
        throw new Error("useHttpContext must be used within HttpProvider");
    }
    return context;
}
